@if (recommendation) { @for (warning of recommendation.warnings; track warning) {
<app-warning [warning]="warning"></app-warning>
} @if (activeTab$ | async; as activeTab) { @if (hasPFDs && hasTechnologies) {
<ul class="tabs">
  @for (tab of tabs; track tab) {
  <li class="tab">
    <a
      class="tab-link"
      [routerLink]="[]"
      [queryParams]="{ recommendationSidebar: tab.name }"
      queryParamsHandling="merge"
      [ngClass]="{ active: activeTab === tab.name }"
    >
      {{ tab.label }}
    </a>
  </li>
  }
</ul>
<app-separator></app-separator>
} @if (hasPFDs && activeTab == 'pfd') {
<div class="tab-header">Recommended PFDs</div>
<div class="tab-container">
  <div class="button-wrapper">
    <button class="iconf-btn-filled download-button" (click)="downloadAllPfds()">
      <fa-icon [icon]="faExternalLinkAlt"></fa-icon>
      download all pfds
    </button>
  </div>
  @for (pfd of recommendation.pfds; track pfd) {
  <app-pfd-outline [pfd]="pfd" (downloadPfd)="downloadPfd($event)" (openPfd)="openPfd($event)"></app-pfd-outline>
  }
</div>
} @if (hasTechnologies && activeTab == 'technology') {
<div class="tab-header">Technology</div>
<div class="tab-container">
  @for (tech of recommendation.technologies; track tech) {
  <div class="technology">{{ tech.name }}</div>
  }
</div>
} } @if (!hasPFDs && !hasTechnologies) {
<h3>no recommendations yet</h3>
} }
